/* unplugin-vue-components disabled */import script from "./UserInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoDialog.vue?vue&type=style&index=0&id=370a4b78&lang=stylus"

const __exports__ = script;

export default __exports__